import React from "react";
import "./AppGridListItem.css";

const AppGridListItem = ({ label = "", value = "" }) => {
  return (
    <div className="app-grid-list-item">
      <div className="item-label">{label}</div>
      <div className="item-value">{value}</div>
    </div>
  );
};

export default AppGridListItem;
